import React from 'react';

import { useConfig } from 'shared/featureFlagConfig/useConfig';

const withConfigFlagGuard = (configKey) => (Component) => (props) =>
  useConfig(configKey) ? <Component {...props} /> : null;

export default withConfigFlagGuard;
